export default "__VITE_ASSET__2e35c430__"